/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { cn } from '@/shared/ui/utils/tailwind';

/** Field label inside a team dialog. */
export const labelClasses = cn(
  'text-[length:var(--text-meta)]',
  'font-[weight:var(--font-medium)]',
  'text-(--text-secondary)',
);

/** Inline validation message under a field. */
export const errorClasses = cn(
  'text-[length:var(--text-meta)]',
  'text-(--status-error-text)',
);

/** Field group wrapper: a borderless fieldset stacking label and control. */
export const fieldsetClasses = 'flex flex-col gap-(--space-1) border-none p-0 m-0';

/** Primary confirm action pinned in the dialog footer. */
export const submitBtnClasses = cn(
  'h-10 px-(--space-5) rounded-(--radius-md) border-none',
  'bg-(--button-primary-bg) text-(--button-primary-text)',
  'text-sm font-semibold cursor-pointer',
  'disabled:opacity-60 disabled:cursor-not-allowed',
);

/** Destructive action, kept visually apart from the confirm action. */
export const dangerBtnClasses = cn(
  'h-10 px-(--space-4) rounded-(--radius-md)',
  'bg-transparent text-(--status-error-text)',
  'border border-(--status-error-border)',
  'text-sm font-semibold cursor-pointer',
);
